import { getPageSize } from "./selectors";

const getPreviousPageNumber = state =>
  Math.floor((state.offset.lower - 1) / getPageSize(state)) + 1;

export default getPreviousPageNumber;
